// Generated by scripts/sync-physics-lab.mjs.
export const PHYSICS_LAB_RUNTIME = {
  "snapshot": "e9f9784994198dfc",
  "entry": "/lab-assets/physics/e9f9784994198dfc/index.html"
} as const;
